import actions from "./actions";

const initialState = {
  error: null,
  loading: false,
  crawler: {},
};

export default function crawlExtractSellingPriceReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CRAWL_EXTRACT_SELLING_PRICE_REQUEST:
      return {
        ...state,
        loading: true,
        crawler: {},
      };
    case actions.CRAWL_EXTRACT_SELLING_PRICE_SUCCESS:
      return {
        ...state,
        loading: false,
        crawler: action.crawler,
      };
    case actions.CRAWL_EXTRACT_SELLING_PRICE_ERROR:
      return {
        ...state,
        loading: false,
        crawler: {},
      };
    case actions.GET_CRAWL_EXTRACT_SELLING_PRICE_REQUEST:
      return {
        ...state,
        crawler: {},
      };
    case actions.GET_CRAWL_EXTRACT_SELLING_PRICE_SUCCESS:
      return {
        ...state,
        crawler: action.crawler,
      };
    case actions.GET_CRAWL_EXTRACT_SELLING_PRICE_ERROR:
      return {
        ...state,
        crawler: {},
        error: action.error,
      };
    default:
      return state;
  }
}
